export default {"src":"/_next/static/media/hot_tub.e749f87d.svg","height":100,"width":100};